import { Trans } from "react-i18next";

const News7 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##7"}
            components={{
                section: <section />,
                h3: <h3>""</h3>,
                p: <p />,
                ul: <ul />,
                li: <li />,
                strong: <strong />
            }}
        />
    );
};

export { News7 };
